import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/thum_img/kp708b/sub5_2/5f7076d0ff8b7fd9951e7cd22cf3bb26_water__c1_w280_h397.jpg'


const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { class: "menu-A-read-wrap" }
const _hoisted_5 = { class: "btn" }

import BoardNavbar from "@/views/product/activity/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";

export default /*@__PURE__*/_defineComponent({
  __name: 'High',
  setup(__props) {

const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(isLoggedIn))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Banner, {
          title: "Activity",
          subtitle: "Activity",
          description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
        }),
        _createVNode(BoardNavbar),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "sub_subject" }, "성장–폴리오 과정", -1)),
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                _createElementVNode("ul", { class: "line line4" }, [
                  _createElementVNode("li", null, "성장 – 폴리오 프로젝트"),
                  _createElementVNode("li", null, [
                    _createElementVNode("dl", { class: "line2" }, [
                      _createElementVNode("dt", null, "제목"),
                      _createElementVNode("dd", null, "성장 – 폴리오_고등학생 과정")
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", null, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("figure", null, [
                      _createVNode(_component_n_space, { justify: "center" }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: ""
                          }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _cache[1] || (_cache[1] = _createStaticVNode("<li data-v-10c11a90><dl data-v-10c11a90><dt data-v-10c11a90>목적</dt><dd data-v-10c11a90> &quot;성장–폴리오_고등학생 과정&quot;은 개인의 재능과 역량을 발굴하고 새로운 경험을 디자인하는 활동으로,<br data-v-10c11a90> 자신의 &#39;성장시스템&#39; 구축 과정을 통해 자아 발견하고, 이를 기반으로 자아성장틀을 제작하는 데 목적이 있다.<br data-v-10c11a90></dd></dl><dl data-v-10c11a90><dt data-v-10c11a90>목표</dt><dd data-v-10c11a90> 목표1. 미미한 또는 숨겨진 역량-재능, 활동 및 경험을 브레인스토밍 한다. <br data-v-10c11a90> 목표2. 발굴해 낸 재능 및 역량, 활동 및 경험을 (활동지의)&#39;성장모델&#39;에 입력하여, &#39;MY 성장시스템&#39;을 생성한다.<br data-v-10c11a90> 목표3. &#39;MY 성장시스템&#39;의 역량-재능에 캐릭터 혹은 스토리를 부여하여, &#39;특별한 나&#39;, &#39;최고의 나&#39;를 만드는 경험 지도를 완성한다. <br data-v-10c11a90> 목표4. 모든 참가자가 &#39;MY 성장시스템&#39;을 발표한다. 이때 또래 평가를 진행한다.<br data-v-10c11a90></dd></dl><dl data-v-10c11a90><dt data-v-10c11a90>대상</dt><dd data-v-10c11a90>고1 – 고3<br data-v-10c11a90></dd></dl><dl class=\"line2\" data-v-10c11a90><dt data-v-10c11a90>구분·시수</dt><dd data-v-10c11a90>4시간</dd></dl></li>", 1))
                ])
              ]),
              _cache[4] || (_cache[4] = _createStaticVNode("<div data-v-10c11a90><ul class=\"line line4\" data-v-10c11a90><li data-v-10c11a90> 결과물<br data-v-10c11a90> &#39;MY 성장시스템&#39;<br data-v-10c11a90><br data-v-10c11a90></li><li data-v-10c11a90><dl class=\"line2\" data-v-10c11a90><dt data-v-10c11a90>구성</dt><dd data-v-10c11a90> • 모듈 1. [강의] (1) 프로그램 소개 , (2) 안전 교육<br data-v-10c11a90> • 모듈 2. 재능 및 역량, 활동 및 경험 브레인스토밍<br data-v-10c11a90> • 모듈 3. 재능 및 역량, 활동 및 경험 캐기<br data-v-10c11a90> • 모듈 4. 재능 및 역량, 활동 및 경험 디자인<br data-v-10c11a90> • 모듈 5. &#39;MY 성장시스템&#39;의 발표 및 평가<br data-v-10c11a90><br data-v-10c11a90></dd></dl></li></ul></div><div data-v-10c11a90><ul class=\"line box22\" data-v-10c11a90><li data-v-10c11a90> 강의<br data-v-10c11a90> • 선발 및 진학 전문가<br data-v-10c11a90> • &#39;성장–폴리오 전문가 과정&#39; 수료자<br data-v-10c11a90></li><li data-v-10c11a90><dl class=\"line2\" data-v-10c11a90><dt data-v-10c11a90>이수혜택</dt><dd data-v-10c11a90> 전공 및 직업 탐색, 대학 진학 등의 상황에서 자기소개 자료 제작의 기초 자료로 활용하거나 Port-folio로 활용<br data-v-10c11a90><br data-v-10c11a90></dd></dl></li></ul></div>", 2)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: `${_unref(USER_ROUTES).Product.Activity.Growth.Path}`
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("목록")
                  ])),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})